import computeClassName from '../../../../../utils/computeClassName';

const constants = Object.freeze({
  CLASSNAME_BASE: 'block',

  CLASSNAME_TAB_IS_DISABLED: {
    true: {
      TAB_IS_ACTIVE: {
        true: 'text-cc-muted-contrast cursor-auto font-semibold',
        false: 'text-cc-muted-contrast cursor-auto font-light'
      }
    },
    false: {
      TAB_IS_ACTIVE: {
        true: 'text-cc-primary-contrast cursor-auto font-semibold',
        false: 'text-cc-primary-contrast cursor-pointer font-light'
      }
    }
  },

  CLASSNAME_TAB_SIZE: {
    'large': 'text-cc-body-large',
    'medium': 'text-cc-body-medium'
  },

});

function getComputedClassName(propsClassName, tabSize, isTabActive, isTabDisabled) {
  return `${computeClassName(propsClassName, constants.CLASSNAME_BASE)} ${constants.CLASSNAME_TAB_SIZE[tabSize]} ${constants.CLASSNAME_TAB_IS_DISABLED[isTabDisabled].TAB_IS_ACTIVE[isTabActive]}`
}

function getComputedActivationFn(fn, fnArgs) {
  return (event) => {
    event.preventDefault();
    return undefined === fnArgs ? fn() : fn(fnArgs);
  };
}

export default function CCTabLabel(
  {
    tabLabel,
    tabSize,
    isTabActive,
    isTabDisabled,
    tabActivationFn,
    tabActivationFnArgs,
    className
  }
  ) {
  const computedClassName = getComputedClassName(className, tabSize, isTabActive, isTabDisabled);
  let dynamicProps = {};
  if (!isTabDisabled && !!tabActivationFn && ('function' === typeof tabActivationFn)) {
    dynamicProps['onClick'] = getComputedActivationFn(tabActivationFn, tabActivationFnArgs);
  }
  return isTabActive || isTabDisabled ?
    <span className={computedClassName}>{tabLabel}</span>:
    <a href="/" className={computedClassName} {...dynamicProps}>{tabLabel}</a>;
}
